import React from 'react'
import OkCompAdapter from 'OkApp/components/OkCompAdapter'
import ReactRender from './components/ReactRender';
import Editor from './components/Editor';

const AdapterOkComp = (props) => {

  const updateCodeECss = (code, css) => {
    props.editComponent({ uid: props.okComp.uid, code: code, css: css })
  }


  let propsComp = { developer: props.developer, updateCodeECss }


  return <OkCompAdapter {...props} propsComp={propsComp} noStyleStart={true} component={ReactRender} />
}




const modelo = {
  typeComponente: "ReactCssRender",
  field: "campo",
  label: "ReactCssRender",
  noInline: true,
  showCode: true,  
  code: `        
  
  console.log('value',value)
  const Wrapper = ({ children }) => {return (
        <div
          style={{
            background: "papayawhip",
            width: "100%",
            padding: "2rem",
          }}
        >
          {children}
          <div dangerouslySetInnerHTML={{ __html: value||'Exemplo: exibe valor do campo como html' }} />
        </div>
      )};
      
      const Title = () => (
        <h3 style={{ color: "palevioletred" }}>Hello World!</h3>
      );
      
      render(
        <Wrapper>
          <Title />
        </Wrapper>
      );`

}

const ReactRenderComp = {
  typeComponente: "ReactCssRender",
  configView: {
    grupo: 'Avançado',
    nome: 'Componente React/CSS',
    descricao: 'Componente React/CSS',
    helpUrl: 'https://www.google.com.br/',
    modelo,
  },
  Component: AdapterOkComp,
  CompEditor: Editor

}

export default ReactRenderComp;